import store from '@/store/store'

/** checks if the user is logged in
@return { boolean } - if the user is logged in
*/
export const isLoggedIn = () => {
    return !!store.getters['session/getToken']
}

/** checks if the user is logged in
@return { boolean } - if the user is logged in
*/
export const getSessionInfo = () => {
    return store.getters['session/getAllCustomerInfo']
}

/** Add request to pending requests list
@requestInfo { object }
*/
export const addToRequestsList = (requestInfo) => {
    store.dispatch('addToRequestsList', requestInfo)
}

/* Calling action to cancel all pending requests */
export const cancelAllPendingRequests = () => {
    store.dispatch('cancelAllPendingRequests')
}

/** Add to store route params
@requestInfo { object }
*/
export const saveRouteParams = (routeParams) => {
    store.dispatch('saveRouteParams', routeParams)
}

/* Remove from store route params */
export const removeRouteParams = () => {
    store.dispatch('removeRouteParams')
}

/* Getting route params info saved in our store */
export const getRouteParams = () => {
    return store.getters.getRouteParams
}

/* Getting route params info saved in our store */
export const getMobileAppState = () => {
    return store.getters.getMobileAppState
}

/* Remove token modal from being displayed */
export const hideTokenChallengeModal = () => {
    store.dispatch('hideTokenChallengeModal')
}

/* Remove token modal from being displayed */
export const forceLogout = () => {
    store.dispatch('session/forceLogout')
}
